import React from 'react';
import CenterItem from 'app/components/encarcenter/CenterItem';

import classNames from 'classnames/bind';
import styles from './CenterList.module.scss';

const cx = classNames.bind(styles);

function CenterList({ centersList = null }) {
	const lists = centersList.map((center, i) => {
		const { code, centerName, simpleAddress, tel, centerPhone } = center;
		const key = `center${i}`;
		return (
			<CenterItem
				key={key}
				link={code}
				name={centerName}
				simpleAddress={simpleAddress}
				tel={tel}
				centerPhone={centerPhone}
			/>
		);
	});
	return <ul className={cx('list_center')}>{lists}</ul>;
}

export default CenterList;
